import { tKey } from 'ember-intl';
import type { Carate } from 'lumen/models';

export function getLiveshopRateTooltipTranslations(
  carate: Carate | undefined,
  isRateDataValid: boolean,
): {
  text: string;
  title: string;
} {
  if (!carate) {
    return {
      title: tKey('general.missing'),
      text: tKey('general.missing'),
    };
  }

  if (carate.isSoldOut) {
    return {
      title: '',
      text: tKey('channel_pricing.sold_out_tooltip.text'),
    };
  }

  if (
    carate.message === 'rates.roomname.unavailable' ||
    carate.message === 'general.missing'
  ) {
    return {
      title: tKey('channel_pricing.roomname_unavailable.title'),
      text: tKey('channel_pricing.roomname_unavailable.text'),
    };
  }

  if (carate.shoppedValue === undefined || !isRateDataValid) {
    return {
      title: tKey('channel_pricing.no_shopped_price_tooltip.title'),
      text: tKey('channel_pricing.no_shopped_price_tooltip.text'),
    };
  }

  let titleKey: string;
  if (carate.isRateDiscountDetected) {
    titleKey = tKey('channel_pricing.lower_price_tooltip.title');
  } else if (carate.isRateHigherThanExpected) {
    titleKey = tKey('channel_pricing.higher_price_tooltip.title');
  } else if (carate.isRateShoppedValueAsExpected) {
    titleKey = tKey('channel_pricing.matching_price_tooltip.title');
  } else {
    titleKey = tKey('general.missing');
  }

  return {
    title: titleKey,
    text: tKey('channel_pricing.shopped_price_tooltip.text'),
  };
}
